<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="9">
        <c-card-group>
          <c-card [ngStyle]="{'width.%': 44}" class="py-5">
            <c-card-body>
              <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()">
                <h1>Verify & Change Password</h1>
                <!-- <p class="text-medium-emphasis">Please wait while we verify your otp. <br> Do not leave this page.</p> -->
                <p class="text-medium-emphasis">Please enter the OTP sent to email:
                  <strong>{{this.getUserEmail()}}</strong>, and
                  click on verify to proceed.
                </p>
                <c-input-group class="mt-3 mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input type="password" name="password" formControlName="password" autoComplete="password" cFormControl
                    placeholder="New password" />
                </c-input-group>
                <c-input-group class="mt-3 mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input type="password" name="confirmPassword" formControlName="confirmPassword"
                    autoComplete="confirmPassword" cFormControl placeholder="Confirm password" />
                </c-input-group>

                <p class="otp-expires"> OTP expires in <span>{{' ' + minutes + ':' + seconds + ' '}}</span> minutes</p>

                <c-input-group class="mt-3 mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilTag"></svg>
                  </span>
                  <input type="text" name="otp" formControlName="otp" autoComplete="otp" cFormControl
                    placeholder="Enter OTP" />
                </c-input-group>

                <c-row class="mt-3">
                  <c-col xs="6">
                    <button [disabled]="verifyForm.invalid" type="submit" cButton class="px-4" color="primary">
                      Submit
                    </button>
                  </c-col>
                  <c-col class="text-end" xs="6">
                    <button [routerLink]="['/forgot_password']" cButton class="px-0" color="link">
                      Back
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>

          </c-card>
          <c-card [ngStyle]="{'width.%': 44}" class="text-white bg-primary py-5">
            <c-card-body class="text-center d-flex justify-content-center align-items-center" style="height: 100%;">
              <div class="text-center">
                <img width="150px" height="150px" src="./assets/iiitb_logo.png" alt="IIITB Logo">
                <h2>Welcome to IIIT-B 360<sup>o</sup></h2>
              </div>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>